import React, { useEffect, useState } from 'react'
import {
  Checkbox,
  FormControl,
  FormControlLabel,
  InputLabel,
  OutlinedInput,
} from '@mui/material'
import { convertStringToRegex } from '../../utility'

export function RegexInput({
  asRegex,
  setAsRegex,
  caseSensitive,
  setCaseSensitive,
  useGlobal = true,
}: {
  asRegex: RegExp | string
  setAsRegex: (r: RegExp | string) => void
  caseSensitive: boolean
  setCaseSensitive: (b: boolean) => void
  useGlobal?: boolean
}) {
  const [existing, setExisting] = useState('')

  useEffect(() => {
    if (!existing) {
      setAsRegex('')
      return
    }
    const flags: string[] = []
    if (useGlobal) flags.push('g')
    if (!caseSensitive) flags.push('i')
    setAsRegex(convertStringToRegex(existing, flags) ?? existing)
  }, [existing, caseSensitive, setAsRegex, useGlobal])

  const caseCheck = (
    <Checkbox
      checked={caseSensitive}
      onChange={({ target: { checked } }) => setCaseSensitive(checked)}
    />
  )

  const inputLabel = asRegex ? String(asRegex) : existing ? 'INVALID' : ''

  return (
    <>
      <FormControlLabel control={caseCheck} label="Case Sensitive" />
      <FormControl sx={{ m: 1, minWidth: 120, maxWidth: 300 }}>
        <InputLabel shrink>{inputLabel}</InputLabel>
        <OutlinedInput
          notched
          label={inputLabel}
          placeholder="Search For"
          value={existing}
          onChange={({ target: { value } }) => setExisting(value)}
        />
      </FormControl>
    </>
  )
}
